import React from 'react'
import { Link } from 'react-static'
import Moment from 'react-moment'
import PropTypes from 'prop-types'

import pin from '../images/icons/pin.png'

Moment.globalFormat = 'DD/MM/YY'

export default class BlogPostPreview extends React.Component {
  static propTypes = {
    town: PropTypes.string,
    region: PropTypes.string,
    src: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  }

  componentDidMount() {
    if (this.props.loaderHidden) {
      this.imgStyles()
    }
  }

  componentWillReceiveProps(next) {
    const { loaderHidden } = this.props

    if (next.loaderHidden && !loaderHidden) {
      this.imgStyles()
    }
  }

  imgStyles = () => {
    const { src, id } = this.props
    const img = document.querySelector(`.blog-more__image-${id}`)
    img.style.cssText = `background: url(${src}) no-repeat center center; background-size: cover;`
  }

  render() {
    const { title, date, slug, id, src, town, region } = this.props
    return (
      <Link to={`/blog/${slug}`} className="blog-more__content">
        <div className="blog-more__content-body">
          <h4>
            <Moment element="span" parse="YYYY-MM-DD">
              {date}
            </Moment>
          </h4>
          <h3>{title}</h3>
          {town && region && (
            <p className="blog-more__location">
              {`${town}, ${region}`} <img src={pin} alt="location" />
            </p>
          )}
        </div>
        <div className="blog-more__image">
          <div className={`blog-more__image-inner blog-more__image-${id}`} />
          <div className="blog-more__image-overlay" />
          <button className="blog-more__button default-button">View Post</button>
        </div>
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/BlogPostPreview.js